module.exports = __webpack_public_path__ + "static/img/v70ThreeBg-p.230eb41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v70ThreeBg-p.png
// module id = 5nIP
// module chunks = 1